var map = {
	"./notas_fiscais/auxiliares/atividades_servicos/router/routes.js": "fec3",
	"./notas_fiscais/auxiliares/intermediadores/router/routes.js": "eada",
	"./notas_fiscais/auxiliares/naturezas_operacoes/router/routes.js": "fdcb",
	"./notas_fiscais/auxiliares/ncm/router/routes.js": "c28a",
	"./notas_fiscais/auxiliares/tributacoes/router/routes.js": "88f2",
	"./notas_fiscais/dfe/router/routes.js": "e550",
	"./notas_fiscais/nfce/router/routes.js": "773b",
	"./notas_fiscais/nfe/router/routes.js": "69fc",
	"./notas_fiscais/nfse/router/routes.js": "968b",
	"./produtos/auxiliares/campos_extras/router/routes.js": "67c8",
	"./produtos/auxiliares/grades/router/routes.js": "5076",
	"./produtos/auxiliares/grupos_produtos/router/routes.js": "6e26",
	"./produtos/auxiliares/marcas_produtos/router/routes.js": "a3e0",
	"./produtos/auxiliares/unidades_produtos/router/routes.js": "9ce2",
	"./produtos/etiquetas/router/routes.js": "45fa",
	"./produtos/gerenciar_produtos/router/routes.js": "60c7",
	"./produtos/valores_vendas/router/routes.js": "18fb",
	"./relatorios/agendamentos/router/routes.js": "fe04",
	"./relatorios/cadastros/router/routes.js": "64b8",
	"./relatorios/contratos/router/routes.js": "fc9e",
	"./relatorios/curvas_abc/router/routes.js": "95c0",
	"./relatorios/estoque/router/routes.js": "bba1",
	"./relatorios/financeiros/router/routes.js": "aa87",
	"./relatorios/notas_fiscais/router/routes.js": "04a0",
	"./relatorios/ordens_servicos/router/routes.js": "b194",
	"./relatorios/vendas/router/routes.js": "61c1",
	"./servicos/router/routes.js": "284b",
	"./shared/agenda/router/routes.js": "6abc",
	"./shared/auxiliares/ajuda/router/routes.js": "8d08",
	"./shared/auxiliares/atualizacoes/router/routes.js": "795a",
	"./shared/auxiliares/notificacoes/router/routes.js": "0168",
	"./shared/auxiliares/termos/router/routes.js": "d173",
	"./shared/auxiliares/videos_tutoriais/router/routes.js": "2cee",
	"./shared/cadastros/auxiliares/campos_extras/router/routes.js": "02ba",
	"./shared/cadastros/auxiliares/tipos_contatos/router/routes.js": "a848",
	"./shared/cadastros/auxiliares/tipos_enderecos/router/routes.js": "6857",
	"./shared/cadastros/clientes/router/routes.js": "e2ca",
	"./shared/cadastros/fornecedores/router/routes.js": "24c0",
	"./shared/cadastros/funcionarios/router/routes.js": "a4b3",
	"./shared/cadastros/transportadoras/router/routes.js": "dd07",
	"./shared/carteira/router/routes.js": "b4f0",
	"./shared/configuracoes/avisos_email/router/routes.js": "9d46",
	"./shared/configuracoes/backup_dados/router/routes.js": "a744",
	"./shared/configuracoes/certificado_digital/router/routes.js": "52e0",
	"./shared/configuracoes/dominios/router/routes.js": "3acd",
	"./shared/configuracoes/exclusao_dados/router/routes.js": "0b09",
	"./shared/configuracoes/gerais/router/routes.js": "86c1",
	"./shared/configuracoes/grupos_usuarios/router/routes.js": "bd89",
	"./shared/configuracoes/lojas/router/routes.js": "ecf7",
	"./shared/configuracoes/marca_empresa/router/routes.js": "667f",
	"./shared/configuracoes/modelos_emails/router/routes.js": "9343",
	"./shared/configuracoes/permissoes/router/routes.js": "4a4b",
	"./shared/configuracoes/planos/router/routes.js": "6255",
	"./shared/configuracoes/usuarios/router/routes.js": "7fdf",
	"./shared/erros/router/routes.js": "2b05",
	"./shared/relatorios/curvas_abc/router/routes.js": "245e",
	"./shared/relatorios/usuarios_logs/router/routes.js": "4983"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80b1";